import { createApp } from 'vue';
import { createPinia } from 'pinia';
import { VueQueryPlugin } from '@tanstack/vue-query';
import { applyStoredThemeEarly } from '@servepod/ui';
import App from './App.vue';
import { router } from './router';
import './styles.css';

applyStoredThemeEarly();

const app = createApp(App);

app.use(createPinia());
app.use(router);
app.use(VueQueryPlugin, {
  queryClientConfig: {
    defaultOptions: {
      queries: {
        // Pod state changes on its own, so a short stale window keeps the list honest
        // without hammering the API on every focus change.
        staleTime: 5_000,
        refetchOnWindowFocus: true,
        // A 401 or a validation error will not become valid on retry.
        retry: (failureCount: number, error: unknown) => {
          const status = (error as { status?: number }).status ?? 0;
          if (status >= 400 && status < 500) return false;
          return failureCount < 2;
        },
      },
    },
  },
});

app.mount('#app');
